import { render, staticRenderFns } from "./onlineCertificateAdd.vue?vue&type=template&id=7a95cfa3&scoped=true&"
import script from "./onlineCertificateAdd.vue?vue&type=script&lang=js&"
export * from "./onlineCertificateAdd.vue?vue&type=script&lang=js&"
import style0 from "./onlineCertificateAdd.vue?vue&type=style&index=0&id=7a95cfa3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a95cfa3",
  null
  
)

export default component.exports